import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Loading, Wrapper } from "@networkraildigitalfactory/components";
import TabTable from "../TabTable/TabTable";
import styles from "./MyTeam.module.css";
import MyTeamTable from "./MyTeamTable";
import Pagination from "../Pagination/PaginationPage";
import { useUsers } from "../../hooks/useAPI";
import OneToOneFilter from "../Filters/OneToOneFilter";
import useActiveWindow from "../../hooks/useWindow";
import PageTitle from "../PageTitle/PageTitle";

const MyTeam = (props) => {
  const { setOneToOnesFilters, oneToOnesFilters } = props;
  const isWindowActive = useActiveWindow();
  const history = useHistory();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const goToCascadedObjectives = () => {
    history.push("/new-cascaded-objective");
  };

  const [{ data: myTeam }, getMyTeam] = useUsers(
    {
      url: `myTeamPaginated/${pageNumber}`,
      method: "POST",
      data: {
        limit: pageSize,
        financialYear: oneToOnesFilters.year,
      },
    },
    { manual: true }
  );

  const getTeamData = async () => {
    try {
      await getMyTeam();
    } catch (e) {
      console.error(e);
    }
    setTimeout(() => {
      setLoading(false);
    }, 325);
  };

  useEffect(() => {
    document.body.style.overflowX = "visible";
    setLoading(true);
    getTeamData();
  }, [pageNumber, pageSize, oneToOnesFilters.year, isWindowActive]);

  const onPageChange = async (page) => {
    setLoading(true);
    setPageNumber(page);
    getTeamData();
  };

  const onPageSizeChange = (currentPage, size) => {
    setLoading(true);
    setPageSize(size);
    setPageNumber(1);
    getTeamData();
  };

  const onYearChange = (financialYear) => {
    setOneToOnesFilters("year", financialYear);
  };

  const makeTableData = (oneToOnes) => {
    // Pre-fill empty table
    const tableData = [...Array(13)].map((_, i) => {
      return {
        id: null,
        period: i + 1,
        financialYear: oneToOnesFilters.year,
        oneToOneComplete: false,
      };
    });
    if (oneToOnes) {
      oneToOnes.forEach((item) => {
        tableData[item.period - 1] = {
          id: item.id,
          period: item.period,
          year: oneToOnesFilters.year,
          oneToOneComplete: item.isCompleted,
        };
      });
    }
    return tableData;
  };

  const result =
    myTeam &&
    myTeam.data.map((item) => {
      return {
        id: item._id,
        email: item.email,
        name: item.fullName,
        jobtitle: item.jobTitle,
        oneToOnes: makeTableData(item.oneToOnes),
      };
    });

  const tabsList = [
    {
      name: "My Team",
      data: (
        <div id="myteamPanel" className={styles.tabPanel}>
          <div className={styles.periodHeader}>Periodic 1-2-1 Record</div>
          <div className={styles.team_table_wrapper}>
            <MyTeamTable tableData={result} />
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      <Loading loading={loading} />
      <Wrapper maxWidth={1375} align="center">
        <PageTitle
          titleHeader="My Team"
          titleParagraph={[
            "You can view and manage your team members’ objectives, 1-2-1s and performance reviews here. \n\n Click on a team member to view their information.",
          ]}
          buttonText="cascade objective"
          startReviewPrep={goToCascadedObjectives}
        ></PageTitle>
        <div className={styles.row_filters}>
          <OneToOneFilter onYearChange={onYearChange} yearValue={oneToOnesFilters.year} />
        </div>
        {!loading && (
          <>
            <div className={styles.row}>
              <TabTable tabs={tabsList} defaultActive="myteam" />
            </div>
            <div className={styles.paginationRow}>
              <Pagination
                onChange={onPageChange}
                currentPage={pageNumber}
                total={myTeam && myTeam.total}
                pageSize={pageSize}
                onPageSizeChange={onPageSizeChange}
              />
            </div>
          </>
        )}
      </Wrapper>
    </>
  );
};

export default MyTeam;
